import { Service, ValidationsErrorsDomain } from '@repo/core'
import { AxiosInstance } from 'axios'

type ValidationErrorMapper = Record<string, { message: string }>

export const getValidationsErrorsConfig: Service<
  { domain: ValidationsErrorsDomain },
  ValidationErrorMapper
> = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: { domain: ValidationsErrorsDomain }
}) => {
  const { domain } = params
  return await api.get<ValidationErrorMapper>(`validations/${domain}.json`)
}
